import { CountUp } 	from './countup.min.js';

var animations = {
	selectors: [
		'section.hero .possible-text-content',
		'section.cards [class*="card-"]',
		'section.two-columns .possible-text-content',
		'section.columns .possible-text-content',
		'section.text-content .possible-text-content',
	],

	itemCounter: 0,

    init: function() {
        var self = this;

		jQuery.each( self.selectors, function( index, item ){
			jQuery( item ).each(function(){
				jQuery( this ).attr( 'data-visible', '0' );
			});
		});

		self.refresh();

		jQuery( document ).on( 'click', '[data-target]', function(){
			self.refresh();
		});
	},

	countUp: function( elementTiView ) {
		var self = this;
		
		jQuery( elementTiView ).find( '.countup' ).each( function( item ){
			var element = jQuery( this );

			setTimeout( function(){
				element.attr( 'id', `countup${self.itemCounter}` );

				let countUpElement = new CountUp( `countup${self.itemCounter}`, parseInt( element.attr( 'data-to' ) ), {
					prefix: element.attr( 'data-prefix' ),
					suffix: element.attr( 'data-suffix' ),
				});

				countUpElement.start();

				self.itemCounter = self.itemCounter + 1;
			}, 150 );
		});
	},

	refresh: function() {
		var self = this;

		jQuery( '[data-visible]:not( [data-visible="1"] )' ).each( function(){
			if( jQuery( this ).isOnScreen() ) {
				jQuery( this ).attr( 'data-visible', '1' );
				self.countUp( jQuery( this ) );
			}
		});
	},
}

export {
    animations
};
